import { useEffect, useState } from 'react';

/**
 * 스케줄 복사·붙여넣기(#143) 클립보드.
 *
 * 지점 스케줄(일·주·월)과 그룹수업 화면이 같은 클립보드를 본다 — 화면을 옮겨도, 날짜를 옮겨도 남아 있고
 * 같은 카드를 여러 번 붙여넣을 수 있다. 새로고침하면 사라진다(요건상 그 이상은 필요 없다).
 */
let clipboard = null;
const listeners = new Set();

const emit = () => listeners.forEach(listener => listener(clipboard));

export const getScheduleClipboard = () => clipboard;

export const copyToScheduleClipboard = entry => {
  clipboard = entry;
  emit();
};

export const clearScheduleClipboard = () => {
  clipboard = null;
  emit();
};

/** 클립보드 변화를 구독한다. 우클릭 메뉴의 [붙여넣기] 활성 여부가 이 값으로 바뀐다. */
export const useScheduleClipboard = () => {
  const [entry, setEntry] = useState(clipboard);

  useEffect(() => {
    listeners.add(setEntry);
    setEntry(clipboard);
    return () => listeners.delete(setEntry);
  }, []);

  return entry;
};
